import { z } from "zod";
import { FieldType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

export const INFORMATION_FIELD_NAME_MAX_LENGTH = 500;

const baseSchema = z.object({
  name: z
    .string()
    .min(1, "Nazwa pola jest wymagana.")
    .max(100, "Nazwa pola jest za długa."),
  fieldType: z.enum(FieldType, {
    message: "Typ pola jest wymagany.",
  }),
  description: z.string().max(255, "Opis jest za długi.").optional(),
  required: z.boolean(),
});

const choiceSelectionSchema = z.object({
  choices: z
    .array(
      z.object({
        id: z.string(),
        value: z
          .string()
          .min(1, "Nazwa opcji jest wymagana.")
          .max(255, "Nazwa opcji jest za długa, maksymalnie 255 znaków."),
      })
    )
    .min(1, "Wymagana jest co najmniej jedna opcja wyboru."),
  multipleChoice: z.boolean().optional(),
});

const checkboxSchema = z.object({
  label: z
    .string()
    .min(1, "Treść pola jest wymagana.")
    .max(255, "Treść pola jest za długa."),
});

// Display-only field: content is kept in `name`; no description/required.
const informationSchema = z.object({
  fieldType: z.literal(FieldType.INFORMATION),
  name: z
    .string()
    .min(1, "Treść pola jest wymagana.")
    .max(
      INFORMATION_FIELD_NAME_MAX_LENGTH,
      `Treść pola jest za długa, maksymalnie ${INFORMATION_FIELD_NAME_MAX_LENGTH} znaków.`
    ),
});

export const customFieldSchema = z.discriminatedUnion("fieldType", [
  baseSchema.extend({
    fieldType: z.literal(FieldType.TEXT),
  }),
  baseSchema.extend({
    fieldType: z.literal(FieldType.DATE),
  }),
  baseSchema
    .extend({
      fieldType: z.literal(FieldType.CHECKBOX),
    })
    .merge(checkboxSchema),
  baseSchema
    .extend({
      fieldType: z.literal(FieldType.CHOICE_SELECTION),
    })
    .merge(choiceSelectionSchema),
  informationSchema,
]);

export type CustomFieldSchema = z.infer<typeof customFieldSchema>;
